export const SESSION_THRESHOLD_MS = 30 * 60 * 1000;
export const REST_TIMER_MS = 10 * 60 * 1000;

export const formatSet = (set) => {
  const weight = set.weight !== undefined ? Number(set.weight) : NaN;
  const reps = set.reps !== undefined ? Number(set.reps) : NaN;
  const weightText = Number.isFinite(weight) ? `${weight}kg` : "-kg";
  const repsText = Number.isFinite(reps) ? `${reps}回` : "-回";
  return `${weightText} x ${repsText}`;
};

export const formatRestTimer = (ms) => {
  const clamped = Math.min(ms, REST_TIMER_MS);
  const totalSeconds = Math.floor(clamped / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

export const groupSetsBySession = (sets, thresholdMs = SESSION_THRESHOLD_MS) => {
  const sorted = [...(sets || [])].sort(
    (a, b) =>
      new Date(a.recordedAt).getTime() - new Date(b.recordedAt).getTime()
  );

  const groups = [];
  let current = null;
  let lastTime = null;

  sorted.forEach((set) => {
    const time = new Date(set.recordedAt);
    const ts = time.getTime();
    if (Number.isNaN(ts)) return;

    if (!current || ts - lastTime > thresholdMs) {
      if (current) groups.push(current);
      current = { timestamp: time.toISOString(), sets: [] };
    } else {
      current.timestamp = time.toISOString();
    }
    current.sets.push(set);
    lastTime = ts;
  });

  if (current) groups.push(current);
  return groups;
};

export const getCurrentSessionSets = (sets, nowTimestamp) => {
  const grouped = groupSetsBySession(sets);
  if (grouped.length === 0) return [];

  const latestGroup = grouped[grouped.length - 1];
  const lastSet = latestGroup.sets[latestGroup.sets.length - 1];
  const lastTs = new Date(lastSet?.recordedAt).getTime();
  if (
    !Number.isFinite(lastTs) ||
    nowTimestamp - lastTs > SESSION_THRESHOLD_MS
  ) {
    return [];
  }

  return latestGroup.sets
    .map((set) => ({ set, ts: new Date(set.recordedAt).getTime() }))
    .filter(({ ts }) => Number.isFinite(ts))
    .sort((a, b) => b.ts - a.ts)
    .map(({ set, ts }) => ({
      ...set,
      recordedAtTs: ts,
      recordedAtLabel: new Date(ts).toLocaleString(),
    }));
};
